import Vue from "vue";
import Router from "vue-router";
import VueResource from 'vue-resource'
import VueScrollTo from 'vue-scrollto'
import Meta from 'vue-meta'
import VeeValidate from 'vee-validate';
import VueAnalytics from 'vue-analytics'
// import Components from "./pages/Components.vue";
// import Presentation from "./pages/Presentation.vue";
import MainNavbar from "./layout/MainNavbar.vue";
import MainFooter from "./layout/MainFooter.vue";
// import About from "./pages/example-pages/AboutUs.vue";
// import BlogPost from "./pages/example-pages/BlogPost.vue";
// import BlogPosts from "./pages/example-pages/BlogPosts.vue";
// import ContactUs from "./pages/example-pages/ContactUs.vue";
// import LandingPage from "./pages/example-pages/LandingPage.vue";
// import LoginPage from "./pages/example-pages/LoginPage.vue";
// import PricingPage from "./pages/example-pages/PricingPage.vue";
// import EcommercePage from "./pages/example-pages/EcommercePage.vue";
// import ProductPage from "./pages/example-pages/ProductPage.vue";
// import ProfilePage from "./pages/example-pages/ProfilePage.vue";
// import SignUpPage from "./pages/example-pages/SignUpPage.vue";
// import Sections from "./pages/Sections.vue";
import Monitoring from "./pages/Monitoring.vue";
import Controls from "./pages/Controls.vue";
import Engineering from "./pages/Engineering.vue";
import Parts from "./pages/Parts.vue";
import ArticleNew from "./pages/Article_Create.vue";
import ArticleEdit from "./pages/Article_Edit.vue";
import Article from "./pages/Article.vue";
import NotFound from "./pages/404.vue";
import LegacyParts from "./pages/Legacy_Parts.vue";


import Home from "./pages/Home.vue";
Vue.use(VueResource);
Vue.use(Router);
Vue.use(VueScrollTo, {
  container: "body",
  duration: 700,
  easing: "ease",
  offset: 0,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})
Vue.use(Meta)
Vue.use(VeeValidate);

const router = new Router({
  mode: 'history',
  routes: [
    // {
    //   path: "/",
    //   redirect: "/presentation"
    // },
    {
      path: '/services',
      redirect: '/facility-refrigeration-controls'
    },
    {
      path: '/about',
      redirect: '/'
    },
    {
      path: '/contact',
      redirect: '/'
    },
    {
      path: '/parts',
      redirect: '/legacyparts'
    },
    {
      path: "/",
      name: "Home",
      components: {
        default: Home,
        header: MainNavbar,
        footer: MainFooter
      },
      props: {header: {colorOnScroll: 100}}
    },
    {
      path: "/facility-refrigeration-monitoring",
      name: "Facility Refrigeration Monitoring",
      components: {
        default: Monitoring,
        header: MainNavbar,
        footer: MainFooter
      },
      props: {
        header: {
          colorOnScroll: 200
        }
      }
    },
    {
      path: "/facility-refrigeration-controls",
      name: "Facility Refrigeration Controls",
      components: {
        default: Controls,
        header: MainNavbar,
        footer: MainFooter
      },
      props: {
        header: {
          colorOnScroll: 200
        }
      }
    },
    {
      path: "/facility-refrigeration-engineering",
      name: "Facility Refrigeration Engineering",
      components: {
        default: Engineering,
        header: MainNavbar,
        footer: MainFooter
      },
      props: {
        header: {
          colorOnScroll: 200
        }
      }
    },
    {
      path: "/parts",
      name: "Facility Refrigeration Parts",
      components: {
        default: Parts,
        header: MainNavbar,
        footer: MainFooter
      },
      props: {
        header: {
          colorOnScroll: 200
        }
      }
    }, 
    {
      path: "/article/add",
      name: "New Article",
      components: {
        default: ArticleNew,
        header: MainNavbar,
        footer: MainFooter
      },
      props: {
        header: {
          colorOnScroll: 200
        }
      }
    },
    {
      path: "/article/edit",
      name: "Edit Article",
      components: {
        default: ArticleEdit,
        header: MainNavbar,
        footer: MainFooter
      },
      props: {
        header: {
          colorOnScroll: 200
        }
      }
    },
    {
      path: "/article",
      name: "Facility Refrigeration Articles",
      components: {
        default: Article,
        header: MainNavbar,
        footer: MainFooter
      },
      props: {
        header: {
          colorOnScroll: 200
        }
      }
    },
    {
      path: "/legacyparts",
      name: "Facility Refrigeration Legacy Parts",
      components: {
        default: LegacyParts,
        header: MainNavbar,
        footer: MainFooter
      },
      props: {
        header: {
          colorOnScroll: 200
        }
      }
    },
    {
      path: "/sensorstransducers",
      name: "Facility Refrigeration Legacy Parts",
      components: {
        default: LegacyParts,
        header: MainNavbar,
        footer: MainFooter
      },
      props: {
        header: {
          colorOnScroll: 200
        }
      }
    },
    {
      path: "/transducers",
      name: "Facility Refrigeration Legacy Parts",
      components: {
        default: LegacyParts,
        header: MainNavbar,
        footer: MainFooter
      },
      props: {
        header: {
          colorOnScroll: 200
        }
      }
    },
    {
      path: "/danfossparts",
      name: "Facility Refrigeration Legacy Parts",
      components: {
        default: LegacyParts,
        header: MainNavbar,
        footer: MainFooter
      },
      props: {
        header: {
          colorOnScroll: 200
        }
      }
    },
    {
      path: "/eileci",
      name: "Facility Refrigeration Legacy Parts",
      components: {
        default: LegacyParts,
        header: MainNavbar,
        footer: MainFooter
      },
      props: {
        header: {
          colorOnScroll: 200
        }
      }
    },
    {
      path: "/iomodules",
      name: "Facility Refrigeration Legacy Parts",
      components: {
        default: LegacyParts,
        header: MainNavbar,
        footer: MainFooter
      },
      props: {
        header: {
          colorOnScroll: 200
        }
      }
    },
    {
      path: "/emzzx",
      name: "Facility Refrigeration Legacy Parts",
      components: {
        default: LegacyParts,
        header: MainNavbar,
        footer: MainFooter
      },
      props: {
        header: {
          colorOnScroll: 200
        }
      }
    },
    {
      path: '*',
      components: {
        default: NotFound,
        header: MainNavbar,
        footer: MainFooter
      },
      props: {
        header: {
          colorOnScroll: 200
        }
      }
    }
    // {
    //   path: "/components",
    //   name: "components",
    //   components: {default: Components, header: MainNavbar, footer: MainFooter},
    //   props: {
    //     footer: {backgroundColor: 'black'},
    //     header: {colorOnScroll: 65}
    //   }
    // },
    // {
    //   path: "/presentation",
    //   name: "presentation",
    //   components: {default: Presentation, header: MainNavbar, footer: MainFooter},
    //   props: {header: {colorOnScroll: 500}}
    // },
    // {
    //   path: "/about",
    //   name: "about",
    //   components: {default: About, header: MainNavbar, footer: MainFooter},
    //   props: {header: {colorOnScroll: 450}}
    // },
    // {
    //   path: "/contact",
    //   name: "contact",
    //   components: {default: ContactUs, header: MainNavbar, footer: MainFooter},
    //   props: {footer: {type: 'default'}}
    // },
    // {
    //   path: "/login",
    //   name: "login",
    //   components: {default: LoginPage, header: MainNavbar},
    //   props: {header: {colorOnScroll: 450}}
    // },
    // {
    //   path: "/landing",
    //   name: "landing",
    //   components: {default: LandingPage, header: MainNavbar, footer: MainFooter},
    //   props: {footer: {type: 'default'}, header: {colorOnScroll: 450}}
    // },
    // {
    //   path: "/pricing",
    //   name: "pricing",
    //   components: {default: PricingPage, header: MainNavbar, footer: MainFooter},
    //   props: {header: {colorOnScroll: 450}}
    // },
    // {
    //   path: "/blog-post",
    //   name: "blog-post",
    //   components: {default: BlogPost, header: MainNavbar, footer: MainFooter},
    //   props: {header: {colorOnScroll: 450}}
    // },
    // {
    //   path: "/blog-posts",
    //   name: "blog-posts",
    //   components: {default: BlogPosts, header: MainNavbar},
    //   props: {header: {colorOnScroll: 450}}
    // },
    // {
    //   path: "/ecommerce",
    //   name: "ecommerce",
    //   components: {default: EcommercePage, header: MainNavbar, footer: MainFooter},
    //   props: {header: {colorOnScroll: 450}}
    // },
    // {
    //   path: "/product",
    //   name: "product",
    //   components: {default: ProductPage, header: MainNavbar},
    //   props: {header: {colorOnScroll: 450}}
    // },
    // {
    //   path: "/profile",
    //   name: "profile",
    //   components: {default: ProfilePage, header: MainNavbar, footer: MainFooter},
    //   props: {header: {colorOnScroll: 450}}
    // },
    // {
    //   path: "/signup",
    //   name: "signup",
    //   components: {default: SignUpPage, header: MainNavbar},
    //   props: {header: {colorOnScroll: 450}}
    // },
    // {
    //   path: "/sections",
    //   name: "sections",
    //   components: {default: Sections, header: MainNavbar, footer: MainFooter},
    //   props: {
    //     footer: {backgroundColor: 'gray'},
    //     header: {colorOnScroll: 0}
    //   }
    // }
  ],
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  },
});
Vue.use(VueAnalytics, {
  id: ['UA-89795959-13', 'AW-788605961'],
  disableScriptLoader: true,
  router
})
export default router;
